import BFFAPI from './utils/BFFAPI';

class LegalDocumentsAPI extends BFFAPI {
  getLegalDocuments = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}`);
    return this.fetch(req);
  };
}

export default new LegalDocumentsAPI('/fleet/secure/legal-resources');
